import { render, staticRenderFns } from "./ClosedTickets.vue?vue&type=template&id=24b76fbd&scoped=true"
import script from "./ClosedTickets.vue?vue&type=script&lang=js"
export * from "./ClosedTickets.vue?vue&type=script&lang=js"
import style1 from "./ClosedTickets.vue?vue&type=style&index=1&id=24b76fbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b76fbd",
  null
  
)

export default component.exports